const consent = {
  title: "ประกันอัคคีภัยที่อยู่อาศัยแบบประหยัดสำหรับรายย่อย (Micro Insurance)",
  description: `ประกันอัคคีภัยที่อยู่อาศัยแบบประหยัดสำหรับรายย่อย (Micro Insurance)
  เบี้ยประกันภัยราคาเดียว 400 บาทต่อปี (รวมอากรและภาษี)
  `,
  benefits: [
    {
      title: "",
      detail: "ความคุ้มครอง",
      items: [
        {
          index: "1. ทุนประกันภัย 300,000 บาท",
        },
        {
          index:
            "2. คุ้มครองเฉพาะสิ่งปลูกสร้าง (ไม่รวมฐานราก) และใช้เป็นที่อยู่อาศัยเท่านั้น",
        },
        {
          index: "3. เฉพาะสิ่งปลูกสร้างชั้น 1 (คอนกรีตล้วน) เท่านั้น",
        },
        {
          index: "4. ระยะเวลาคุ้มครอง 1 ปี",
        },
      ],
    },
  ],
  conditions: [
    {
      title: "",
      detail: "เงื่อนไขการรับประกันภัย",
      items: [
        {
          index:
            "1. ไฟไหม้ ฟ้าผ่า ระเบิด คุ้มครองตามความเสียหายจริงสูงสุดไม่เกิน 300,000 บาท",
        },
        {
          index:
            "2. ลมพายุ, น้ำท่วม, แผ่นดินไหว, ภูเขาไฟระเบิด, คลื่นใต้น้ำ, สึนามิ, ลูกเห็บ ทุกภัยรวมกันไม่เกิน 100,000 บาทต่อปี",
        },
        {
          index:
            "3. ค่าเช่าที่อยู่อาศัยชั่วคราว กรณีสิ่งปลูกสร้างได้รับความเสียหาย จนเป็นผลให้ผู้เอาประกันภัยต้องหาที่พักอาศัยชั่วคราว วันละ 300 บาท สูงสุดไม่เกิน 30 วัน ตลอดระยะเวลาเอาประกันภัย",
        },
      ],
    },
  ],
  exceptions: [],
  services: [
    {
      title: "",
      detail: "ศูนย์บริการลูกค้า (Customer Service Center)",
      items: [
        {
          index: "<li> ทาง Call Center โทร.1484",
        },
      ],
    },
  ],
};

export default consent;
